import { computed } from '@vue/composition-api'

function compareArraysLengths(a, b) {
  return a?.length > 0 && b?.length > 0 && a?.length === b?.length
}

function getPairsOfValues(respostasAtuais, respostasAnteriores) {
  const pairs = []
  let respostaAtual = {}
  let respostaAnterior = {}
  for (let index = 0; index < respostasAtuais.length; index += 1) {
    respostaAtual = respostasAtuais[index]
    respostaAnterior = respostasAnteriores[index]

    pairs.push({
      contentTitle: respostaAtual.formularioElemento,
      currentValue: respostaAtual.formularioElementoOpcao || respostaAtual.respostaTexto || respostaAtual.respostaBool,
      previousValue:
        respostaAnterior.formularioElementoOpcaoAnterior ||
        respostaAnterior.respostaTextoAnterior ||
        respostaAnterior.respostaBoolAnterior,
    })
  }
  return pairs.length ? pairs : null
}

export default function useFormulariosRespostasAlteracoes(historico) {
  const respostasForamAlteradas = computed(() =>
    compareArraysLengths(historico.value.formulariosRespostasAtuais, historico.value.formulariosRespostasAnteriores),
  )

  const paresDeValoresRespostasAtuaisEAnteriores = computed(() =>
    respostasForamAlteradas.value
      ? getPairsOfValues(historico.value.formulariosRespostasAtuais, historico.value.formulariosRespostasAnteriores)
      : [],
  )

  return { respostasForamAlteradas, paresDeValoresRespostasAtuaisEAnteriores }
}
